import _ from 'lodash';

// Expand virtual money descriptors into one flat column per target, for tabular export
// (CSV / Markdown / HTML). The export mirrors what the cell's tooltip shows: every target the row
// actually carries becomes a column.
//
// Reporting targets (static `currency`) always export — they resolve for every row. Per-row targets
// (the source and restatements, identified by `currencyPath`) export only when at least one row carries
// a value at the source path; that's exactly when the tooltip surfaces them. Aggregate rows have no
// source value, so summary exports stay free of empty source columns.
//
// Each expanded column reads from the source's row path and is labeled "<base> (<CUR|target label>)":
// reporting targets use the currency code ("Cost (USD)"), per-row targets use the source's tooltip
// label ("Cost (Expense Currency)", "Cost (Project Currency)"). `role: 'metric'` keeps numeric
// alignment in the renderers. Used by the in-table CSV download and the copy/markdown/HTML export so
// the three stay in lockstep. Non-money fields (and money fields without resolved sources) pass
// through unchanged.
export function expandMoneyFields(fields, data = []) {
  return fields.flatMap((field) => {
    if (field.semantic !== 'money' || !Array.isArray(field.money?.sources)) return [field];
    const baseLabel = field.exportLabel ?? field.label;
    return field.money.sources
      .filter((src) => src.currency || data.some((row) => _.get(row, src.path) != null))
      .map((src) => {
        const suffix = src.currency ?? src.label;
        const label = suffix ? `${baseLabel} (${suffix})` : baseLabel;
        return {
          ...field,
          semantic: undefined,
          money: undefined,
          key: src.path,
          path: src.path,
          label,
          exportLabel: label,
          role: 'metric',
        };
      });
  });
}
